module.exports = __webpack_public_path__ + "static/Cuboh-131e8d277bc8899bc7c328caf6104501.jpg";